import * as React from "react";
import Tooltip from "../../Tooltip/Tooltip";
import { TooltipType } from "../../types/Tooltip";
import { Builder } from "@builder.io/react";

const TooltipWrapper = ({ copy }: TooltipType) => {
  return <Tooltip copy={copy} />;
};

export default TooltipWrapper;

export const RegisterTooltip = () => {
  Builder.registerComponent(Tooltip, {
    name: "tooltip-molecule",
    inputs: [
      {
        name: "copy",
        type: "longText",
      },
    ],
  });
};
